import { FC } from 'react';
import styled from 'styled-components';

// Shared UI Components
import Button from '../Button/Button';
import { SadBaseballIcon } from '../../assets';

// Styled Components
const StyledErrorView = styled.article`
  margin-top: 5rem;
  display: flex;
  justify-content: center;
`;

const HeadingOne = styled.h1`
  margin: 0.5rem 0;
  font-weight: 600;
  font-size: 1.5rem;
`;

const ErrorContainer = styled.div`
  max-width: 23.5rem;
  display: flex;
  flex-direction: column;
`;

const IconContainer = styled.header`
  text-align: center;
  margin-bottom: 1.5rem;
  svg {
    width: 6.25rem;
    height: 6.25rem;
  }
`;

const Body = styled.div`
  margin-bottom: 1.5rem;
`;

const Paragraph = styled.p`
  font-weight: 200;
  margin: 0;
`;

const Link = styled.a`
  text-align: center;
  font-size: 0.875rem;
  margin-top: 0.5rem;
  text-decoration: none;
  font-weight: 500;
  &:link,
  &:visited,
  &:active {
    color: ${(props) => props.theme['linkColor']};
  }
`;

const FullWidthButton = styled.div`
  width: 100%;
`;

// Props
export interface ErrorViewProps {
  title: string;
  message: string;
  className?: string;
  onClick?: () => void;
  buttonText?: string;
  url?: string;
  urlText?: string;
  urlInNewTab?: boolean;
  SvgHeaderIcon?: FC<React.SVGProps<SVGSVGElement>>;
  ButtonComponent?: FC<React.ButtonHTMLAttributes<HTMLButtonElement>>;
}

export const ErrorView = ({
  className,
  message,
  title,
  url,
  urlText,
  onClick,
  buttonText,
  urlInNewTab,
  SvgHeaderIcon = SadBaseballIcon,
  ButtonComponent = Button,
}: ErrorViewProps) => {
  return (
    <StyledErrorView className={className}>
      <ErrorContainer>
        <IconContainer>
          <SvgHeaderIcon />
        </IconContainer>
        <Body>
          <HeadingOne>{title}</HeadingOne>
          <Paragraph>{message}</Paragraph>
        </Body>
        {onClick && buttonText && (
          <FullWidthButton as={ButtonComponent} onClick={onClick}>
            {buttonText}
          </FullWidthButton>
        )}
        {url && urlText && (
          <Link
            href={url}
            target={urlInNewTab ? '_blank' : '_self'}
            rel={urlInNewTab ? 'noopener noreferrer' : ''}
          >
            {urlText}
          </Link>
        )}
      </ErrorContainer>
    </StyledErrorView>
  );
};

export default ErrorView;
